// extracted by mini-css-extract-plugin
export var activationContainer = "Activation-module--activationContainer--kTOP0";
export var activationGrid = "Activation-module--activationGrid--D1Wgj";
export var cardTitle = "Activation-module--cardTitle--tN3hT";
export var bottomContainer = "Activation-module--bottomContainer--7FdWv";
export var description = "Activation-module--description--XoXBf";
export var buttonContainer = "Activation-module--buttonContainer--YazlE";
export var versionText = "Activation-module--versionText--BT5ON";
export var showMoreButtonContainer = "Activation-module--showMoreButtonContainer--WO0DM";
export var showMoreButton = "Activation-module--showMoreButton--1l8Qw";